export default __webpack_public_path__ + "static/media/overview_elite islamic.6bcba54f.gif";